/* Pole Mom — "Hulp nodig bij het kiezen?" pop-up (gedrag).
   Gebruikt window.PolemomTabs uit polemom-shared.js voor de NL/EN-tabs
   binnen de pop-up. */
(function () {
  function initModals(scope) {
    (scope || document).querySelectorAll('[data-polemom-open]').forEach(trigger => {
      if (trigger.dataset.polemomInit === "1") return;
      trigger.dataset.polemomInit = "1";

      trigger.addEventListener('click', () => {
        const modal = document.getElementById(trigger.getAttribute('data-polemom-open'));
        if (!modal) return;
        modal.hidden = false;
        document.body.classList.add('polemom-modal-open');
        if (window.PolemomTabs) {
          window.PolemomTabs.init(modal.querySelector('[data-polemom-tabs]'));
        }
        const closeBtn = modal.querySelector('.polemom-modal__close');
        if (closeBtn) closeBtn.focus();
      });
    });

    (scope || document).querySelectorAll('[data-polemom-modal]').forEach(modal => {
      if (modal.dataset.polemomInit === "1") return;
      modal.dataset.polemomInit = "1";

      // Belangrijk: verplaats de modal naar <body>. Anders erft "position:
      // fixed" de containing block van een voorouder met een CSS transform
      // (bv. de scroll-trigger fade-in animaties van het thema), waardoor
      // de pop-up in een klein hoekje verschijnt i.p.v. over het hele scherm.
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      const dialog = modal.querySelector('.polemom-modal__dialog');

      function closeModal() {
        modal.hidden = true;
        document.body.classList.remove('polemom-modal-open');
      }

      // Eén gedelegeerde click-listener: sluit op het kruisje (of iets met
      // data-polemom-close), of als de klik buiten de dialoog landt.
      modal.addEventListener('click', (e) => {
        const clickedCloseEl = e.target.closest('[data-polemom-close]');
        const clickedOutsideDialog = dialog && !dialog.contains(e.target);
        if (clickedCloseEl || clickedOutsideDialog) {
          closeModal();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initModals());
  document.addEventListener('shopify:section:load', (e) => initModals(e.target));
})();
